import { CustomNextPage } from '../lib/types';
import { bootstrap } from '../lib/bootstrap';
import { PostCheckout } from '../modules/PostCheckout';
import { CheckoutValueContextProvider } from '../modules/CheckoutValueContext';

const PostCheckoutPage: CustomNextPage<{}> = () => {
  return (
    <CheckoutValueContextProvider storageKey="BuyProductCheckout">
      <PostCheckout />
    </CheckoutValueContextProvider>
  );
};

export default bootstrap(PostCheckoutPage);
